import _defineProperty from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _table;

export default {
  route: {
    dashboard: "首页",
    dept: "部门管理",
    system: "系统管理",
    pos: "岗位管理",
    role: "角色管理",
    menu: "菜单管理",
    user: "用户管理",
    deviceMgt: "设备管理",
    device: "设备维护",
    alarm: "告警管理",
    collection: "采集点管理",
    linkageMgt: "联动配置管理",
    linkage: "联动配置",
    linkageLog: "联动日志",
    accessControl: "门禁系统",
    InformationDelivery: "信息发布系统",
    oneCard: "一卡通系统",
    parkingLot: "停车场系统",
    ba: "楼宇自控",
    hvacSystem: "空调系统",
    lightSystem: "照明系统",
    waterSystem: "给排水系统",
    energy: "能耗系统",
    energySystem: "能耗系统",
    log: "日志管理",
    informationManager: "基础信息管理"
  },
  navbar: {
    logOut: "退出登录",
    dashboard: "首页",
    screenfull: "全屏",
    theme: "换肤"
  },
  login: {
    title: "系统登录",
    logIn: "登录",
    username: "账号",
    password: "密码"
  },
  table: (_table = {
    dynamicTips1: "固定表头, 按照表头顺序排序",
    dynamicTips2: "不固定表头, 按照点击顺序排序",
    dragTips1: "默认顺序",
    dragTips2: "拖拽后顺序",
    id: "序号",
    actions: "操作",
    // 部门 start
    deptName: "部门名称",
    deptId: "部门ID",
    upDeptName: "上级部门名称",
    deptOrder: "部门排序",
    deptDesc: "部门描述",
    // 部门 end
    // 角色 strart
    roleName: "角色名称",
    roleUsers: "角色成员",
    roleRemark: "角色描述",
    opDate: "创建时间",
    // 角色 end
    // 职位 strart
    posDesc: "岗位描述",
    // 职位 end
    // 日志 strart
    menuName: "系统功能名称",
    operateTypeName: "操作类型名称",
    userName: "用户名",
    userAcc: "用户账号",
    ipAddress: "ip地址",
    executeResultJson: "执行结果描述",
    executeResult: "执行结果",
    // 日志 end
    // 采集点管理
    deviceName: "设备名称",
    deviceSerno: "设备编码",
    collectionTypeName: "采集点类型",
    collectionUnitName: "采集点单位",
    collectionName: "采集点名称",
    collectionSerno: "采集点编码",
    collectionOrder: "采集点排序",
    isEnable: "是否启用",
    collectionDesc: "采集点描述",
    collectionUrl: "采集点地址",
    isState: "是否状态",
    // 采集点管理
    // 用户 start
    posName: "职位",
    mobilephone: "手机号",
    userState: "状态",
    aspRemark: "账号描述",
    editPwd: "密码",
    userPwd: "用户密码",
    // 用户 end
    // 一卡通 start
    cardSerno: "卡号",
    cardUsername: "持卡人",
    cardUserphone: "持卡人电话",
    cardType: "卡类型",
    cardState: "卡状态",
    IsEnable: "是否挂失",
    // 一卡通 end
    // 门禁系统 start
    floor: "楼层",
    floorLocation: "所在楼层",
    belongFloor: "楼层名称",
    floorAlias: "楼层别名",
    floorSort: "楼层排序",
    openType: "开门类型",
    cardDate: "刷卡时间",
    // 门禁系统 end
    // 停车场 start
    cardHolder: "持卡人姓名",
    // cardType: '',
    plateNumber: "车牌",
    inDate: "入场时间",
    outDate: "出场时间",
    inState: "入场状态",
    outState: "出场状态",
    charge: "收费",
    charegName: "收费人员",
    whenLong: "停车时长",
    inPicture: "入场图片",
    outPicture: "出场图片",
    // 停车场 end
    // 信息发布 start
    messageTitle: "标题",
    messageContent: "内容",
    messageLevel: "消息级别",
    releaseFlag: "发布标识",
    // 信息发布 end
    // 菜单管理 start
    menuId: "菜单ID",
    menuMenuName: "菜单名称",
    menuType: "菜单类型",
    menuUrl: "菜单地址",
    menuUpidName: "上级菜单名称",
    menuIcon: "菜单图标",
    menuIconOut: "菜单图标_Moveout",
    menuOrder: "菜单排序",
    isDel: "是否删除",
    menuTarget: "菜单目标",
    menuDesc: "菜单描述",
    menuVueUrl: "菜单地址",
    menuVirtualUrl: "虚拟菜单地址",
    menuVueTarget: "菜单目标",
    logOpDate: "操作时间",
    // 菜单管理 end
    // 楼层管理 start
    partitionName: "分区",
    floorName: "楼层名称",
    floorAliasName: "楼层别名",
    // 楼层管理 end
    // 设备管理 start
    brandName: "品牌名称",
    brandNameValue: "品牌名称",
    deviceAddress: "安装位置",
    deviceDesc: "相关描述",
    deviceFlag: "设备标识",
    deviceId: "设备ID",
    deviceIp: "设备IP",
    deviceState: "设备状态",
    entSerno: "企业编码",
    equipType: "设备型号",
    floorId: "所属楼层ID",
    sysType: "归属系统",
    sysTypeName: "所属系统",
    targetIds: "设备标签",
    devupdateTime: "最后更新时间",
    estateDeviceId: "物管设备ID",
    // 设备管理 end
    // 采集点管理  start
    collectionType: "采集点类型",
    collectionPosition: "采集点位置",
    collectionUnit: "采集点单位",
    // 采集点管理  end
    // 设备联动 start
    isDelete: "是否删除",
    linkageContent: "联动内容",
    linkageDesc: "联动描述",
    linkageDeviceId: "联动设备",
    linkageDeviceName: "联动设备名称",
    linkageEvent: "联动事件",
    linkageMethod: "方法编码",
    linkageName: "联动名称",
    linkageSysType: "联动系统",
    linkageSysTypeName: "联动系统名称",
    // 设备联动 end
    // 设备标签管理 start
    targetName: "标签名称",
    targetId: "标签ID",
    targetNames: "标签名称",
    deviceNames: "设备名称",
    targetIcon: "标签图标",
    // 设备标签管理 end
    // 告警管理 start
    ackedCount: "确认总数",
    alarmContent: "告警内容",
    alarmLevel: "告警级别",
    alarmTime: "告警时间",
    collectionId: "采集点ID",
    alarmPosition: "告警源",
    collectionStatus: "告警状态",
    unAckedCount: "未应答数",
    ackedCountOrUnAckedCount: "未应答数/确认总数",
    ackContent: "处理内容",
    ackDate: "应答时间",
    ackState: "应答状态",
    ackUser: "应答用户",
    alarmClass: "告警分类",
    alarmDate: "告警时间",
    alarmId: "告警ID",
    msgText: "告警内容",
    op: "",
    presentValue: "现值",
    priority: "告警级别",
    sourceName: "告警源",
    status: "状态",
    fromState: "上一状态",
    toState: "当前状态",
    lowLimit: "低位值 ",
    offNormalValue: "不正常值",
    highLimit: "高位值",
    // 告警管理 end
    // 能耗历史记录 start
    collectionDate: "采集时间",
    collectionDay: "日",
    collectionMonth: "月",
    collectionYear: "日",
    energy: "累计冷量(KW.h)",
    energyH: "累计冷量（高位）",
    energyL: "累计冷量（低位）",
    flow: "瞬时流量(L/h)",
    flowH: "瞬时流量（高位）",
    flowL: "瞬时流量（低位）",
    power: "功率(W)",
    powerH: "功率（高位）",
    powerL: "功率（低位）",
    state: "",
    tempIn: "进水温度(℃)",
    tempOut: "出水温度(℃)",
    totalFlow: "累计流量(m³)",
    totalFlowH: "累计流量（高位）",
    totalFlowL: "累计流量（低位）",
    // 能耗历史记录 end
    // 联动日志  START
    alarm: "告警ID",
    execDate: "执行时间",
    execDesc: "执行描述",
    execResult: "执行结果",
    logId: "联动日志ID",
    // 联动日志 END
    // porisAccessRecord
    accessTime: "通行时间",
    cardId: "卡内码",
    porisCardState: "通行状态",
    // cardSerno: '卡编号',
    // cardState: '卡状态',
    // cardType: '卡类型',
    // deptName: '部门名称',
    deptNo: "部门编号",
    doorId: "门点标识",
    doorName: "门点名称",
    // id: ' 一卡通ID ',
    // isDel: '是否删除',
    // isEnable: '是否可用',
    // op: '',
    // opDate: '',
    userId: "人员ID",
    // userName: '人员名称',
    userNo: "人员编号",
    // porisAccessRecord
    // 楼层统计能量
    ahu1H: "1#空调(热)",
    ahu1C: "1#空调(冷)",
    ahu2C: "2#空调(冷)",
    ahu2H: "2#空调(热)",
    fcuh: "风机盘管(热)",
    fcuc: "风机盘管(冷)",
    // poris门设备状态
    description: "描述",
    deviceType: "设备类型",
    doorState: "门状态",
    lastStateTime: "更新时间",
    upDoorId: "父级门点标识",
    // poris门设备流水
    mngCode: "门点管理码",
    updateTime: "状态更新时间",
    // 工单情况
    recordId: "告警ID",
    orderId: "订单ID",
    externalId: "外部工单ID",
    orderStatus: "工单状态",
    dealTime: "处理时间",
    currentOrderStatus: "工单当前状态",
    // 联动逻辑字典表
    methodId: "联动方法ID",
    logicDesc: "逻辑描述",
    paramJson: "方法参数",
    // 联动方法字典表
    // linkageMethod: '方法编码',
    linkageMethodName: "方法名称",
    methodType: "方法类型",
    methodFlag: "是否启用",
    methodName: "方法名称",
    // description: '描述'
    remark: "备注",
    generateTime: "生成时间",
    relation: "逻辑关系",
    // 流程管理
    modelId: "模型id",
    modelName: "模型名称",
    modelKey: "模型key",
    type: "类型",
    commonUsed: "常用",
    opTime: "操作时间",
    isCommonUsed: "是否常用",
    processModel: "流程模型",
    formName: "表单名称",
    formTitle: "表单标题",
    creator: "创建者",
    deletedMark: "删除标志",
    instId: "实例编号",
    billName: "单据名",
    starterName: "发起人",
    startTime: "发起时间",
    nextUserName: "下节点操作人",
    duration: "持续时间",
    groupName: "班组名称",
    groupExplain: "班组说明",
    persons: "人员",
    inspectionName: "巡检名称",
    inspectionUser: "巡检人员",
    inspectionTime: "巡检时刻",
    inspectionExplain: "巡检说明",
    inspectionEndTime: "巡检结束时间",
    groupDetail: "班组详情",
    deviceDetail: "设备详情",
    isPublish: "是否发布",
    devicePictures: "设备图片",
    chooseDevice: "选择设备",
    taskNo: "任务编号",
    taskName: "任务名",
    track: "跟踪图",
    stateName: "任务状态",
    // 能耗类型
    energyTypeName: "类型名称",
    energySerno: "类型编码",
    formula: "转换煤公式",
    changePriceLevel: "请选择价格档位",
    // 能耗价格
    priceLevelName: "档位名称",
    lvalue: "下限值",
    mvalue: "上限值",
    levelPrice: "档位价格（元）",
    // 能耗分类报表
    time: "时间",
    electric: "电",
    consumption: "用量(度)",
    cost: "费用(十元)",
    water: "水",
    gas: "气",
    centralHeating: "集中供热",
    centralCooling: "集中供热冷",
    otherEnergy: "其他能源",
    // 仪表类型
    meterName: "仪表名",
    meterUnint: "计量单位",
    // 小区名称管理
    precinctName: "小区名称名称",
    precincGrouptName: "小区分组名称",
    precinctPhone: "电话",
    ownerPhone: "业主电话",
    precinctAddr: "地址",
    area: "面积(m²)",
    greenArea: "绿化面积(m²)",
    usableArea: "使用面积(m²)",
    shareArea: "公摊面积(m²)",
    greeningRate: "绿化率(%)",
    plotRatio: "容积率(%)",
    buildTime: "建筑时间",
    completionTime: "交房时间",
    // 楼栋管理
    superior: "上级机构",
    buildingName: "名称",
    buildingSeq: "序号",
    buildingFloor: "层数",
    buildingType: "类型",
    buildingUse: "用途",
    orientation: "朝向",
    building: "楼栋",
    buildingAlias: "楼宇",
    directorialArea: "管理区域",
    explain: "说明",
    areaGroupIdName: "上级机构",
    roomCode: "房间代码",
    roomState: "房间状态",
    curCustom: "当前业主",
    customInfo: "业主信息",
    moveBack: "迁入迁出",
    moveDate: "迁出日期",
    isMoveCost: "是否迁移费用",
    newCustomer: "新业主",
    roomType: "房间类型",
    customer: "客户",
    contactNumber: "联系电话",
    buildArea: "建筑面积(m²)",
    useArea: "使用面积(m²)",
    roomSeq: "门牌号",
    unitName: "单元名称",
    initialAcceptanceDate: "初次验收日期",
    secondAcceptanceDate: "二次验收日期",
    houseIsRentable: "能否出租",
    memberRelationship: "家庭成员",
    irregularitiesRectification: "违规整改",
    garageName: "车库名称",
    undergroundParking: "地下停车场",
    parkingCode: "车位号",
    subsidiaryGarage: "所属车库",
    parkingOwner: "车位业主",
    parkingArea: "车位面积(m²)",
    leaseControl: "租赁控制",
    curState: "当前状态",
    saleDate: "出售日期",
    carNumberOne: "车牌号1",
    carNumberTwo: "车牌号2",
    parkingType: "车位类别",
    advCode: "广告位号",
    chargeProject: "收费项目",
    timeFrame: "应收时段",
    outTime: "迁出时间",
    // 报修
    repairTotal: "报修总数",
    waitDistribute: "待分配",
    untreated: "未处理",
    processed: "处理中",
    completed: "已完成",
    filed: "已归档",
    satisfactionNumber: "满意数",
    satisfaction: "满意度",
    repairPerson: "报修人",
    repairMan: "报修人员",
    repairDevice: "报修设备",
    positionInfo: "位置信息",
    houseBelong: "所属房间",
    appointTo: "指派给",
    redeployTo: "转派给",
    sendExtandAddr: "派工地址",
    sendExtandTime: "派工时间",
    sendExtandRemark: "派工备注",
    repairContact: "报修人员联系方式",
    addPeople: "添加人",
    addPeopleContact: "联系方式",
    addTime: "添加时间",
    appointmentTime: "预约时间",
    source: "来源",
    house: "房间",
    maintainPerson: "维修人员",
    finishTime: "完成时间"
  }, _defineProperty(_table, "op", "维修人"), _defineProperty(_table, "performance", "完成情况"), _defineProperty(_table, "orderStatue", "工单状态"), _defineProperty(_table, "repairContent", "报事报修内容"), _defineProperty(_table, "customerType", "客户类型"), _defineProperty(_table, "listNumber", "单号"), _defineProperty(_table, "repairNum", "报修单号"), _defineProperty(_table, "processTime", "受理时间"), _defineProperty(_table, "processMan", "受理人"), _defineProperty(_table, "contactMan", "联系人"), _defineProperty(_table, "repairType", "报修类型"), _defineProperty(_table, "repairDetail", "报修详情"), _defineProperty(_table, "position", "位置"), _defineProperty(_table, "installPosition", "安装位置"), _defineProperty(_table, "pecinct", "小区名称"), _defineProperty(_table, "urgencyDegree", "紧急程度"), _defineProperty(_table, "workOrderType", "工单大类"), _defineProperty(_table, "classWorkList", "工单子类"), _defineProperty(_table, "evaluate", "评价"), _defineProperty(_table, "valuateContent", "评价内容"), _defineProperty(_table, "grade", "等级"), _defineProperty(_table, "houseCode", "房间代码"), _defineProperty(_table, "reservation", "预约时间"), _defineProperty(_table, "place", "地点"), _defineProperty(_table, "handler", "处理人"), _defineProperty(_table, "data", "日期"), _defineProperty(_table, "detailInfo", "详情情况"), _defineProperty(_table, "processRecord", "处理记录"), _defineProperty(_table, "name", "名称"), _defineProperty(_table, "customerName", "客户名称"), _defineProperty(_table, "customerNumber", "编号"), _defineProperty(_table, "customerPhone", "电话"), _defineProperty(_table, "fax", "传真"), _defineProperty(_table, "phoneOne", "联系电话1"), _defineProperty(_table, "phoneTwo", "联系电话2"), _defineProperty(_table, "phoneThree", "联系电话3"), _defineProperty(_table, "email", "电子邮箱"), _defineProperty(_table, "mailbox", "邮箱"), _defineProperty(_table, "documentType", "证件类型"), _defineProperty(_table, "documentNumber", "证件号码"), _defineProperty(_table, "sex", "性别"), _defineProperty(_table, "birthday", "出生日期"), _defineProperty(_table, "nativePlace", "籍贯"), _defineProperty(_table, "currentAddress", "现住地址"), _defineProperty(_table, "companyType", "公司类型"), _defineProperty(_table, "IDNumber", "身份证号码"), _defineProperty(_table, "QQ", "QQ"), _defineProperty(_table, "weiNumber", "微信号"), _defineProperty(_table, "profession", "职业"), _defineProperty(_table, "hobby", "兴趣爱好"), _defineProperty(_table, "censusAddr", "户籍地址"), _defineProperty(_table, "companyNature", "公司性质"), _defineProperty(_table, "companyNum", "公司人数"), _defineProperty(_table, "companyAccountName", "公司开户名称"), _defineProperty(_table, "companyBankAccount", "银行账号"), _defineProperty(_table, "companyCreditCode", "统一社会信用代码"), _defineProperty(_table, "companyLicence", "执照有效期"), _defineProperty(_table, "companyLegal", "法人代表"), _defineProperty(_table, "phoneNumber", "电话号码"), _defineProperty(_table, "companyPhoneFax", "单位传真"), _defineProperty(_table, "managementArea", "所属小区名称"), _defineProperty(_table, "areaBelong", "所属区域"), _defineProperty(_table, "areaGroup", "所属小区分组"), _defineProperty(_table, "buildingBelong", "所属楼栋"), _defineProperty(_table, "wechatNum", "微信号"), _defineProperty(_table, "loginAccount", "登录账户"), _defineProperty(_table, "bindingHouse", "绑定房屋"), _defineProperty(_table, "auditStatus", "审核状态"), _defineProperty(_table, "personName", "姓名"), _defineProperty(_table, "visitUserName", "访问对象"), _defineProperty(_table, "visitUserMobile", "访问对象手机号"), _defineProperty(_table, "arrangePerson", "安排人员"), _defineProperty(_table, "arrangeRemark", "安排说明"), _defineProperty(_table, "handSuggestion", "处理意见"), _defineProperty(_table, "upLoadRepairImg", "报修图片"), _defineProperty(_table, "cifrmUserPwd", "确认密码"), _defineProperty(_table, "parkName", "园区名称"), _defineProperty(_table, "assetCoding", "资产编码"), _defineProperty(_table, "assetName", "资产名称"), _defineProperty(_table, "purchaseTime", "购入时间"), _defineProperty(_table, "userDept", "使用部门"), _defineProperty(_table, "number", "数量"), _defineProperty(_table, "originalValue", "资产原值(元)"), _defineProperty(_table, "accumulatedDiscount", "累计折旧"), _defineProperty(_table, "capitalAccount", "资产净值(元)"), _defineProperty(_table, "profitAndLoss", "是否盈亏"), _defineProperty(_table, "classify", "分类"), _defineProperty(_table, "actualCapitalAccount", "实际资产净值(元)"), _defineProperty(_table, "personLiable", "责任人"), _defineProperty(_table, "reason", "原因"), _defineProperty(_table, "depositPlace", "存入地点"), _defineProperty(_table, "capitalState", "状态"), _defineProperty(_table, "uploadImg", "上传图片"), _defineProperty(_table, "materialName", "材料名称"), _defineProperty(_table, "brand", "品牌"), _defineProperty(_table, "specification", "规格型号"), _defineProperty(_table, "unit", "单位"), _defineProperty(_table, "supplierName", "名称"), _defineProperty(_table, "fixedPhone", "固定电话"), _defineProperty(_table, "mobilePhone", "手机"), _defineProperty(_table, "warehousename", "仓库名称"), _defineProperty(_table, "chargePerson", "负责人"), _defineProperty(_table, "additionalTime", "新增时间"), _defineProperty(_table, "actionsState", "操作状态"), _defineProperty(_table, "actionDate", "操作日期"), _defineProperty(_table, "supplier", "供应商"), _defineProperty(_table, "receipt", "入库"), _defineProperty(_table, "retrieval", "出库"), _defineProperty(_table, "retrievalNum", "出库单号"), _defineProperty(_table, "receiptOrderNum", "入库单号"), _defineProperty(_table, "billDate", "单据日期"), _defineProperty(_table, "warehouse", "仓库"), _defineProperty(_table, "makingPeople", "制单人"), _defineProperty(_table, "costPrice", "成本价(元)"), _defineProperty(_table, "amount", "金额(元)"), _defineProperty(_table, "totalAmount", "合计金额(元)"), _defineProperty(_table, "receiptListDetail", "详细入库列表"), _defineProperty(_table, "retrievalListDetail", "详细出库列表"), _defineProperty(_table, "goodsName", "商品名称"), _defineProperty(_table, "summation", "合计(元)"), _defineProperty(_table, "unitPrice", "单价(元)"), _defineProperty(_table, "isReturnNum", "可退数量"), _defineProperty(_table, "returnQuantity", "退货数量"), _defineProperty(_table, "returnAmount", "退货金额"), _defineProperty(_table, "document", "单据"), _defineProperty(_table, "documentNum", "单据号"), _defineProperty(_table, "importance", "重要程度"), _defineProperty(_table, "currentInventory", "当前库存"), _defineProperty(_table, "inventoryNum", "库存数量"), _defineProperty(_table, "referencePrice", "参考价格"), _defineProperty(_table, "unitCost", "单位成本"), _defineProperty(_table, "primeCost", "成本(元)"), _defineProperty(_table, "modelNum", "规格型号"), _defineProperty(_table, "requirements", "要求处理事项"), _defineProperty(_table, "consumptionDepartment", "领用部门"), _defineProperty(_table, "departmentName", "部门名"), _defineProperty(_table, "goAndGet", "本次拟领取数量"), _defineProperty(_table, "retrievalPrice", "出库价"), _defineProperty(_table, "pointName", "名称"), _defineProperty(_table, "pointCode", "编号"), _defineProperty(_table, "pointStatus", "状态"), _defineProperty(_table, "pointRemark", "备注"), _defineProperty(_table, "patrolPointsCount", "巡更点数量"), _defineProperty(_table, "searchPoints", "选择巡更点"), _defineProperty(_table, "sort", "调整顺序"), _defineProperty(_table, "patrolPlant", "日巡更计划"), _defineProperty(_table, "lineName", "名称"), _defineProperty(_table, "lineCode", "编号"), _defineProperty(_table, "lineStatus", "状态"), _defineProperty(_table, "lineRemark", "备注"), _defineProperty(_table, "applyName", "申请人姓名"), _defineProperty(_table, "applyPhone", "申请人电话"), _defineProperty(_table, "applyTime", "申请时间"), _defineProperty(_table, "subjectMatter", "事由"), _defineProperty(_table, "useNumber", "用车人数"), _defineProperty(_table, "carOutTime", "出发时间"), _defineProperty(_table, "carBackTime", "返回时间"), _defineProperty(_table, "origin", "出发地"), _defineProperty(_table, "destination", "目的地"), _defineProperty(_table, "attachFile", "文件"), _defineProperty(_table, "applyStatus", "状态"), _defineProperty(_table, "timeSpan", "时间段"), _defineProperty(_table, "useCount", "用车次数"), _defineProperty(_table, "meetingRoomName", "会议室名称"), _defineProperty(_table, "meetingName", "会议名称"), _defineProperty(_table, "meetingRoomDesc", "会议室描述"), _defineProperty(_table, "meetingRoom", "会议室"), _defineProperty(_table, "meetingRoomAddr", "会议室地址"), _defineProperty(_table, "meetingRoomCapacity", "会议室容量(人)"), _defineProperty(_table, "isVideo", "是否有投影仪"), _defineProperty(_table, "isTv", "是否有电视"), _defineProperty(_table, "isSound", "是否有音响"), _defineProperty(_table, "isComputer", "是否有电脑"), _defineProperty(_table, "applyDate", "申请日期"), _defineProperty(_table, "flowNumber", "流程编号"), _defineProperty(_table, "department", "所属部门"), _defineProperty(_table, "meetingThemes", "会议主题"), _defineProperty(_table, "Attendees", "参会人员"), _defineProperty(_table, "beginTime", "开始时间"), _defineProperty(_table, "endTime", "结束时间"), _defineProperty(_table, "contentOverview", "内容概述"), _defineProperty(_table, "Minutes", "会议纪要"), _defineProperty(_table, "meetingTimeSpan", "会议时间"), _defineProperty(_table, "externalEquipmentID", "外部扩展ID"), _defineProperty(_table, "meetingFiles", "会议文件"), _table),
  button: {
    batchAdd: "批量新增",
    check: "查看",
    checkDetail: "查看明细",
    uninstall: "卸载",
    deployment: "部署",
    search: "搜索",
    add: "添加",
    export: "导出",
    importMateriel: "导入物料",
    chooseImportFile: "选择导入文件",
    materielTemplate: "下载物料导入模板",
    edit: "编辑",
    publish: "发布",
    draft: "草稿",
    delete: "删除",
    cancel: "取 消",
    confirm: "确 定",
    affirm: "确认",
    print: "打印",
    enable: "启用",
    disable: "禁用",
    editPwd: "修改密码",
    start: "开始",
    build: "生成",
    pickUp: "接警",
    pickOut: "标记",
    sendExtand: "派单",
    exec: "执行记录",
    log: "日志记录",
    track: "跟踪图",
    claim: "认领",
    revoke: "撤销",
    submit: "提 交",
    relation: "绑定设备",
    contrast: "对比",
    determine: "确定",
    exportExcel: "导出Excel",
    changeProprietor: "绑定业主",
    changeProprietorHistory: "绑定业主历史记录",
    addPakinglotoa: "添加车位",
    bindingOwner: "绑定业主",
    bindingHouse: "绑定房屋",
    finish: "完成",
    redeploy: "转派",
    archive: "归档",
    applyPostpone: "申请延期",
    evaluate: "评价",
    maintainRemark: "维修追加说明",
    auditPass: "通过",
    auditUnPass: "不通过",
    verify: "审核",
    save: "保存",
    picking: "领料",
    returned: "退料",
    cancellation: "作废",
    recover: "恢复",
    normal: "正常",
    showQRCode: "查看二维码",
    plantDetail: "计划详情",
    close: "关闭"
  }
};